import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { HideFooter, HideHeader, StructuredPageData } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Page, SignInPage as SignInPageV2, useFeatureFlags } from "@sonic-equipment/ui";
import SignInPageV1 from "@sonic/Overrides/Pages/SignInPageV1";
import { customerState } from "@sonic/Store/GemecoState";
import * as React from "react";
import { connect } from "react-redux";

const enum fields {
    image = "image",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
    };
}

const mapStateToProps = (state: customerState) => {
    const location = getLocation(state);
    const queryString = parseQueryString<{ returnUrl?: string }>(location.search);
    return {
        returnUrl: queryString.returnUrl,
    };
};

type Props = ReturnType<typeof mapStateToProps> & PageProps & OwnProps;

export function SignInPage({ returnUrl, ...props }: Props) {
    const { checkoutV1 } = useFeatureFlags();

    if (checkoutV1) {
        // eslint-disable-next-line react/jsx-pascal-case
        return <SignInPageV1.component {...props} />;
    }
    return (
        <Page fullHeight fluid={true} data-test-selector="signIn">
            <SignInPageV2 returnUrl={returnUrl} />
        </Page>
    );
}

const pageModule: PageModule = {
    component: connect(mapStateToProps)(SignInPage),
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: false,
        supportsProductSelection: true,
        pageType: "System",
        fieldDefinitions: [StructuredPageData, HideHeader, HideFooter],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "SignInPagePage" instead of this constant.
 */
export const SignInPageContext = "SignInPagePage";
